import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import type { ModelId } from "@content/prepSchema";
import type { ModelProps } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyModel = LazyExoticComponent<ComponentType<ModelProps<any>>>;

/** Each model is loaded only when selected in the workbench. */
export const MODEL_COMPONENTS: Record<ModelId, AnyModel> = {
  "energy-momentum": lazy(() => import("./energy-momentum/EnergyMomentumModel")),
  doppler: lazy(() => import("./doppler/DopplerModel")),
  spacetime: lazy(() => import("./spacetime/SpacetimeModel")),
  blackbody: lazy(() => import("./blackbody/BlackbodyModel")),
  photoelectric: lazy(() => import("./photoelectric/PhotoelectricModel")),
  compton: lazy(() => import("./compton/ComptonModel")),
  xray: lazy(() => import("./xray/XrayModel")),
  pair: lazy(() => import("./pair/PairModel")),
  "matter-wave": lazy(() => import("./matter-wave/MatterWaveModel")),
  detections: lazy(() => import("./detections/DetectionsModel")),
  "wave-packet": lazy(() => import("./wave-packet/WavePacketModel")),
  "bohr-atom": lazy(() => import("./bohr-atom/BohrAtomModel")),
  populations: lazy(() => import("./populations/PopulationsModel")),
  collision: lazy(() => import("./collision/CollisionModel")),
  "well-states": lazy(() => import("./well-states/WellStatesModel")),
  "tunnel-barrier": lazy(() => import("./tunnel-barrier/TunnelBarrierModel")),
  "wave-function": lazy(() => import("./wave-function/WaveFunctionModel")),
  superposition: lazy(() => import("./superposition/SuperpositionModel")),
  "hydrogen-states": lazy(() => import("./hydrogen-states/HydrogenStatesModel")),
  zeeman: lazy(() => import("./zeeman/ZeemanModel")),
  shells: lazy(() => import("./shells/ShellsModel")),
  "molecular-orbital": lazy(() => import("./molecular-orbital/MolecularOrbitalModel")),
  occupation: lazy(() => import("./occupation/OccupationModel")),
  rovibration: lazy(() => import("./rovibration/RovibrationModel")),
};
